/**
 * Live blocks: server-owned markup inside a message's content (`<tool_call>`,
 * `<image_generation>`) that opens with `<tag><id>…</id>` and is replaced in
 * place as its work progresses. Mirrors the server's `upsertBlock`, so the
 * streamed copy and the saved message stay identical.
 */
export interface BlockPatch {
  tag: 'tool_call' | 'image_generation';
  id: string;
  /** The block's full markup; empty removes the block. */
  xml: string;
}

const escapeXmlText = (text: string): string =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export const unescapeXmlText = (text: string): string =>
  text.includes('&')
    ? text.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
    : text;

/** Replaces the block with the patch's id, or appends it when there is none. */
export const upsertBlock = (content: string, { tag, id, xml }: BlockPatch): string => {
  const start = content.indexOf(`<${tag}><id>${escapeXmlText(id)}</id>`);
  const close = `</${tag}>`;
  const closeIndex = start === -1 ? -1 : content.indexOf(close, start);
  if (closeIndex === -1) return xml ? content + xml : content;
  return content.slice(0, start) + xml + content.slice(closeIndex + close.length);
};
